import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: string;
  prefix?: string;
  color?: string;
}

export default function Icon({
  name,
  prefix = 'icon',
  color = '#333',
  ...props
}: IconProps) {
  const symbolId = `#${prefix}-${name}`;

  return (
    <svg {...props} aria-hidden="true">
      <use href={symbolId} fill={color} />
    </svg>
  );
}
